import { RegisterUserMutationVariables } from '../../API';
import { Typography } from '@mui/material';
import React from 'react';

export function DataProtectionPolicyGerman({
  currentData,
}: {
  currentData: Partial<RegisterUserMutationVariables>;
}) {
  return (
    <>
      <Typography align="center">
        <b>Vereinbarung über Teilnehmendeninformation und Datenschutz (TID)</b>
        <br />
        <b>für die Nutzung der MIND.set-Plattform</b>
        <br /> <br />
        Zwischen den
        <br />
        <br />
        Deutsches Zentrum für Integrations- und Migrationsforschung (DeZIM) e.V.
        <br />
        Mauerstraße 76, 10117 Berlin, vertreten durch den Vorstand
        <br />- Nachstehend <b>"DeZIM"</b> genannt -<br />
        <br />
        und
        <br />
        <br />
        {currentData.name}
        <br />
        <br />- Nachfolgend als <b>"Nutzende”</b> bezeichnet -<br />
        <br />
        Nachfolgend gemeinsam als Parteien bezeichnet, wird die folgende
        Vereinbarung über die Einräumung von Nutzungsrechten und die
        Verarbeitung von Mikrodaten des DeZIM geschlossen:
      </Typography>
      <br />
      <Typography>
        <b>§ 1 Vereinbarungsgegenstand und Anwendungsbereich der TID</b>
        <br />
        <br />
        (1) Die Vereinbarung Information und Datenschutz für Teilnehmende (TID)
        dient der Festlegung der allgemeinen Bedingungen, Rechte und Pflichten
        hinsichtlich der Teilnehmendeninformation und des Datenschutzes zwischen
        dem Deutschen Zentrum für Integrations- und Migrationsforschung DeZIM
        e.V. (DeZIM) und den registrierten Nutzenden (“Nutzenden”) im Hinblick
        auf Datenerhebungen mit der MIND.set-Plattform (“MIND.set”).
        <br />
        <br />
        (2) Mit der Zustimmung zur TID-Nutzungsvereinbarung versichern die sich
        bei MIND.set registrierenden Personen ("Nutzende"), dass sie für die
        Einhaltung der nachfolgenden Bedingungen zur Teilnehmendeninformation
        und zum Datenschutz verantwortlich sind.
        <br />
        <br />
        (3) MIND.set bietet einen Service für die Erstellung von psychologischen
        Tests und deren Einbindung in Online-Umfragen an. Der Nutzende ist
        verantwortlich für:
        <br />
        <ul>
          <li>
            Die Durchführung des Forschungsvorhabens erfolgt unter strikter
            Einhaltung der Datenschutzbestimmungen der DSGVO. Dies betrifft
            insbesondere die Rechtsgrundlage für die Verarbeitung
            personenbezogener Daten: Eine Verarbeitung ist nur zulässig, wenn
            die betroffenen Personen ihre Einwilligung gemäß Art. 6 Abs. 1 lit.
            a und, sofern relevant, Art. 9 Abs. 2 lit. a DSGVO erteilt haben.
            Besondere Beachtung finden dabei die Informationspflichten sowie die
            Wahrung weiterer Rechte der Betroffenen gemäß Art. 12-20 DSGVO.
          </li>
          <li>
            Die Durchführung des Forschungsvorhabens unter Einhaltung ethischer
            Forschungsstandards sowie der Standards guter wissenschaftlicher
            Praxis. Hierzu gehört insbesondere eine transparente Information der
            Teilnehmenden über Ziele, Inhalte und Ablauf der Studie sowie eine
            informierte Einwilligung in die Teilnahme an der Studie.
          </li>
        </ul>
        <br />
        (4) Der Nutzende verpflichtet sich, nachfolgenden Bestimmungen bzgl. der
        Informationen für Studienteilnehmende und deren Einwilligungen Folge zu
        leisten.
        <br />
        <br />
        <b>
          § 2 Allgemeine Teilnehmendeninformation und Informierte Einwilligung
          in Studienteilnahme
        </b>
        <br />
        <br />
        Jede mit MIND.set durchgeführte Studie muss die Befragten mit den
        folgenden <b>Informationen</b> versorgen:
        <br />
        <ul>
          <li>
            Name, Adresse und E-Mail-Adresse der für die Studie verantwortlichen
            Person/Einrichtung
          </li>
          <li>Kontaktinformationen für Fragen zur Teilnahme an der Studie</li>
          <li>Inhalt und Ziel der Studie</li>
          <li>Zweck der Datenerhebung</li>
          <li>Zugang zu den gesammelten Daten (gemeinsame Datennutzung)</li>
          <li>
            Informationen über die Freiwilligkeit der Teilnahme an der Studie
            und die Anonymität der erhobenen Daten (d. h. Angabe, ob die Daten
            in anonymisierter/pseudonymisierter Form erhoben und verarbeitet
            werden)
          </li>
        </ul>
        Zwingender Bestandteil dieses Dokuments ist zudem ein Formular zur
        Einholung einer <b>informierten Zustimmung (Informed Consent)</b>.
        <br />
        <br />
        Folgende Formulierung wird empfohlen: "Mit Ihrer Zustimmung zur
        Teilnahme an der Umfrage und zur Verarbeitung Ihrer Daten bestätigen
        Sie, dass Sie die oben beschriebenen Punkte verstanden haben und damit
        einverstanden sind: Ich habe die Teilnahmeinformationen zur Studie
        gelesen und willige ein, an dieser Studie teilzunehmen. Ich kann meine
        Einwilligung widerrufen.”
        <br />
        <br />
        <b>§ 3 Informationen zur Verarbeitung personenbezogener Daten</b>
        <br />
        <br />
        <b>
          Ergänzend zu der in § 2 genannten allgemeinen Teilnehmendeninformation
          muss
        </b>{' '}
        jeder Nutzende von MIND.set den Befragten in einem{' '}
        <b>
          separaten Dokument Informationen zur Verarbeitung personenbezogener
          Daten
        </b>{' '}
        zur Verfügung stellen. Hierfür ist die{' '}
        <a href={'https://osf.io/kau3m'} target={'_blank'}>
          Vorlage in Anhang 1
        </a>{' '}
        zu nutzen.
        <br />
        <br />
        <b>§ 4 Vereinbarungsverstoß</b>
        <br />
        <br />
        (1) Verstößt der Nutzende gegen die sich aus §2 und §3 der Vereinbarung
        ergebenden Pflichten, so hat er das DeZIM unverzüglich zu informieren.
        Der Nutzende hat nach Möglichkeit zu versuchen, die vorgenannten
        Pflichten zur Teilnehmendeninformation nachträglich zu erfüllen, z.B.
        den Studienaufbau zu verbessern und bereits teilgenommen Personen
        nachträglich über die vorgenannten Punkte zu informieren.
        <br />
        <br />
        (2) Das DeZIM ist berechtigt, bei einem Verstoß gegen eine der
        vorgenannten Pflichten sowie bei Fehlschlagen der Nacherfüllung und der
        Schwere des Falles eine oder mehrere der folgenden Maßnahmen zu
        ergreifen:
        <ul>
          <li>
            Das DeZIM behält sich das Recht vor, solche Nutzende mit sofortiger
            Wirkung von der Plattform auszuschließen. Das Recht zur Nutzung der
            MIND.set-Plattform und zum Empfang und zur Nutzung der rechtswidrig
            erhobenen Daten erlischt mit sofortiger Wirkung.
          </li>
          <li>
            Das DeZIM behält sich vor, die Forschungsdatenzentren, die Mitglied
            im Ständigen Ausschuss für Forschungsdateninfrastruktur (FDI) und im
            RatSWD sind, über den Verstoß zu informieren;
          </li>
          <li>
            Das DeZIM behält sich das Recht vor, den Nutzende vorübergehend oder
            dauerhaft von der Nutzung der DeZIM-Dienste auszuschließen.
          </li>
        </ul>
        (3) Der Nutzende verpflichtet sich für den Fall einer vorsätzlichen oder
        grob fahrlässigen Verletzung von Vereinbarungspflichten zur Zahlung
        einer Vereinbarungsstrafe in Höhe von 100.000€ (Euro).
        <br />
        <br />
        <b>§ 5 Haftung</b>
        <br />
        <br />
        (1) Der Nutzende haftet gegenüber dem DeZIM für alle Schäden, die durch
        unsachgemäße, fahrlässige und unzureichende Bereitstellung von
        Teilnahmeinformationen und Datenschutz an die Teilnehmenden entstehen.
        <br />
        <br />
        (2) Das DeZIM haftet gegenüber dem Nutzende nicht für Verluste oder
        Schäden jeglicher Art im Zusammenhang mit dem Vereinbarungsgegenstand
        oder mit Schlussfolgerungen oder Empfehlungen, die in den damit
        verbundenen Informationen enthalten sein können. Der Nutzende erkennt
        hiermit an, dass sie*er allein für die Folgen der Handlungen
        verantwortlich ist, die auf der Grundlage der erhaltenen Daten oder als
        Ergebnis ihrer Interpretation vorgenommen werden können.
        <br />
        <br />
        <b>§ 6 Änderungen der Vereinbarung</b>
        <br />
        <br />
        (1) Änderungen oder Ergänzungen dieser Vereinbarung bedürfen zu ihrer
        Wirksamkeit der Textform.
        <br />
        <br />
        (2) Sollten einzelne Bestimmungen dieser Vereinbarung, z.B. im Falle von
        Änderungen oder Ergänzungen gemäß Absatz 1, auch in der geänderten oder
        ergänzten Fassung, unwirksam sein oder werden, so bleibt die Wirksamkeit
        der übrigen, damit nicht zusammenhängenden Bestimmungen unberührt. In
        diesem Fall ist die unwirksame Bestimmung durch eine Regelung zu
        ersetzen, die dem wirtschaftlichen Zweck der unwirksamen Bestimmung im
        Wege der Vereinbarungsergänzung am nächsten kommt.
        <br />
        <br />
        (3) Bei Meinungsverschiedenheiten über Inhalt und Umfang des
        Nutzungsrechts entscheidet das DeZIM.
        <br />
        <br />
        (4) Es wird die Anwendung deutschen Rechts vereinbart. Ausschließlicher
        Gerichtsstand ist Berlin.
        <br />
        <br />
      </Typography>
    </>
  );
}

export function DataProtectionPolicyEnglish({
  currentData,
}: {
  currentData: Partial<RegisterUserMutationVariables>;
}) {
  return (
    <>
      <Typography align="center">
        <b>Agreement on Participant Information and Data Protection (PIDP) </b>
        <br />
        <b>for the use of the MIND.set platform</b>
        <br /> <br />
        Between the
        <br />
        <br />
        German Center for Integration and Migration Research (DeZIM) e.V.
        <br />
        Mauerstraße 76, 10117 Berlin, represented by the Executive Board
        <br />- Hereinafter referred to as <b>"DeZIM"</b> -<br />
        <br />
        and
        <br />
        <br />
        {currentData.name}
        <br />
        <br />- Hereinafter referred to as <b>"users”</b> -<br />
        <br />
        Hereinafter jointly referred to as the Parties, the following agreement
        is concluded on the granting of rights of use and the processing of
        DeZIM microdata:
      </Typography>
      <br />
      <Typography>
        <b>
          § 1 Subject matter of the agreement and scope of application of the
          PIDP
        </b>
        <br />
        <br />
        (1) The purpose of the Participant Information and Data Protection
        Agreement (PIDP) is to define the general conditions, rights and
        obligations regarding participant information and data protection
        between the German Center for Integration and Migration Research DeZIM
        e.V. (“DeZIM“) and the registered users ("users") with regard to data
        collection using the MIND.set platform ("MIND.set").
        <br />
        <br />
        (2) By agreeing to the PIDP user agreement, the persons registering with
        MIND.set ("users") assure that they are responsible for complying with
        the following conditions on participant information and data protection.
        <br />
        <br />
        (3) MIND.set offers a service for the creation of psychological tests
        and their integration into online surveys. The user is responsible for:
        <ul>
          <li>
            The research project is carried out in strict compliance with the
            data protection provisions of the GDPR. This applies in particular
            to the legal basis for the processing of personal data: Processing
            is only permitted if the data subjects have given their consent in
            accordance with Art. 6 para. 1 lit. and, if relevant, Art. 9 para. 2
            lit. a GDPR. Particular attention is paid to the information
            obligations and the protection of other rights of the data subjects
            in accordance with Art. 12-20 GDPR.
          </li>
          <li>
            The implementation of the research project in compliance with
            ethical research standards and the standards of good scientific
            practice. In particular, this includes providing participants with
            transparent information about the objectives, content and procedure
            of the study as well as informed consent to participate in the
            study.
          </li>
        </ul>
        (4) The user undertakes to comply with the following provisions
        regarding information for study participants and their consent.
        <br />
        <br />
        <b>
          § 2 General participant information and informed consent to study
          participation
        </b>
        <br />
        <br />
        Every study conducted with MIND.set must provide respondents with the
        following <b>information</b>:
        <ul>
          <li>
            Name, address and e-mail address of the person/institution
            responsible for the study
          </li>
          <li>
            Contact information for questions regarding participation in the
            study
          </li>
          <li>Content and aim of the study</li>
          <li>Purpose of data collection</li>
          <li>Access to the collected data (data sharing)</li>
          <li>
            Information on the voluntary nature of participation in the study
            and the anonymity of the data collected (i.e. whether the data is
            collected and processed in anonymized/pseudonymized form)
          </li>
        </ul>
        A mandatory component of this document is also a form for obtaining{' '}
        <b>informed consent</b>.
        <br />
        <br />
        The following wording is recommended: "By agreeing to participate in the
        survey and to the processing of your data, you confirm that you have
        understood and agree to the points described above: I have read the
        participation information for the study and agree to participate in this
        study. I can revoke my consent."
        <br />
        <br />
        <b>§ 3 Information on the processing of personal data</b>
        <br />
        <br />
        <b>
          In addition to the general participant information mentioned in § 2
        </b>
        , each user of MIND.set <b>must</b> provide respondents{' '}
        <b>with information on the processing of personal data</b> in a
        <b>separate document</b>. The{' '}
        <a href={'https://osf.io/e6bg7'} target={'_blank'}>
          template in Appendix 1
        </a>{' '}
        is to be used for this purpose.
        <br />
        <br />
        <b>§ 4 Breach of agreement</b>
        <br />
        <br />
        (1) If the user violates the obligations arising from §2 and §3 of the
        agreement, they must inform the DeZIM immediately. If possible, the user
        must attempt to subsequently fulfill the aforementioned obligations to
        inform participants, e.g. to improve the study structure and to
        subsequently inform persons who have already participated about the
        aforementioned points.
        <br />
        <br />
        (2) DeZIM is entitled to take one or more of the following measures in
        the event of a breach of one of the aforementioned obligations as well
        as in the event of failure of subsequent performance and the severity of
        the case:
        <ul>
          <li>
            The DeZIM reserves the right to exclude such users from the platform
            with immediate effect. The right to use the MIND.set platform and to
            receive and use the unlawfully collected data expires with immediate
            effect.
          </li>
          <li>
            The DeZIM reserves the right to inform the research data centers
            that are members of the Standing Committee for Research Data
            Infrastructure (FDI) and the German Data Forum (RatSWD) about the
            violation;
          </li>
          <li>
            The DeZIM reserves the right to temporarily or permanently exclude
            the user from using the DeZIM services.
          </li>
        </ul>
        (3) The user undertakes to pay an agreement penalty of 100,000€ (Euro)
        in the event of an intentional or grossly negligent breach of agreement
        obligations.
        <br />
        <br />
        <b>§ 5 Liability</b>
        <br />
        <br />
        (1) The user is liable to DeZIM for all damages caused by improper,
        negligent and inadequate provision of participation information and data
        protection to participants.
        <br />
        <br />
        (2) DeZIM shall not be liable to the user for any loss or damage of any
        kind in connection with the subject matter of the agreement or with any
        conclusions or recommendations that may be contained in the related
        information. The user hereby acknowledges that they are solely
        responsible for the consequences of any actions that may be taken on the
        basis of the data received or as a result of its interpretation.
        <br />
        <br />
        <b>§ 6 Amendments to the agreement</b>
        <br />
        <br />
        (1) Amendments or additions to this agreement must be made in text form
        to be effective.
        <br />
        <br />
        (2) Should individual provisions of this agreement be or become invalid,
        e.g. in the event of amendments or additions pursuant to §6 (1), even in
        the amended or supplemented version, the validity of the remaining,
        unrelated provisions shall remain unaffected. In this case, the invalid
        provision shall be replaced by a provision that comes closest to the
        economic purpose of the invalid provision by way of supplementing the
        agreement.
        <br />
        <br />
        (3) In the event of differences of opinion regarding the content and
        scope of the right of use, DeZIM shall decide.
        <br />
        <br />
        (4) It is agreed that German law shall apply. The exclusive place of
        jurisdiction is Berlin.
        <br />
        <br />
      </Typography>
    </>
  );
}
